import React, { useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import MuiCardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import "../bin/common";
import Grid from "@mui/material/Grid";
import Icon from "./Icon";
import ListingDetails from "./Details";
import Slide from "@mui/material/Slide";
import Love from "./Love";
import { Calculate } from "../routes/calculate";
import AdvertisingToggle from "../UI/AdvertisingToggle";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { Booking } from "../UI/Booking";
import { testSubject } from "../bin/dev";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Log } from "./Log";
import Conversions from "./Conversions";
import { red, orange } from "@mui/material/colors";

const PREFIX = "Listing";

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  cardAction: `${PREFIX}-cardAction`,
  expanded: `${PREFIX}-expanded`,
  flex: `${PREFIX}-flex`,
  heroRoot: `${PREFIX}-heroRoot`,
  heroPrice: `${PREFIX}-heroPrice`,
  photo: `${PREFIX}-photo`,
  icon: `${PREFIX}-icon`,
  iconGroup: `${PREFIX}-iconGroup`,
  qty: `${PREFIX}-qty`,
  line: `${PREFIX}-line`,
  bottomLine: `${PREFIX}-bottomLine`,
  modal: `${PREFIX}-modal`,
  paper: `${PREFIX}-paper`,
  large: `${PREFIX}-large`,
  larger: `${PREFIX}-larger`,
  closeIcon: `${PREFIX}-closeIcon`,
  trimText: `${PREFIX}-trimText`,
  ribbonSoldConditional: `${PREFIX}-ribbonSoldConditional`,
  accordionSummary: `${PREFIX}-accordionSummary`,
};

const _Listing = (props) => {
  const listingRef = useRef();
  const ControlsRoot = styled("div")(() => ({
    display: "flex",
    gap: "0.2rem",
    flexDirection: "column",
    [`& .${classes.flex}`]: {
      display: "flex",
      gap: "1rem",
      flexDirection: "row",
      textAlign: "right",
      justifyContent: "space-between",
      //marginTop: 20,
    },
  }));
  const Root = styled(Card)(({ theme }) => ({
    display: "flex",
    gap: "0.2rem",
    width: "100%",
    backgroundColor: props.expanded === "pnl-" + props.id ? "#14e3ed14" : "white",

    [`& .${classes.root}`]: {
      marginBottom: "1rem",
      padding: 0,
    },

    [`& .${classes.heroRoot}`]: {
      display: "block",
      marginBottom: 15,
    },

    [`& .${classes.accordionSummary}`]: {
      margin: "0",
    },

    [`& .${classes.heroPrice}`]: {
      fontSize: "large",
      color: "whitesmoke",
      fontWeight: "bold",
      textAlign: "end",
      padding: "5px 10px 5px 10px",
      borderRadius: "5px 0 0 5px",
      boxShadow: "3px 3px 5px black",
      position: "absolute",
      right: "0",
      top: "10px",
      zIndex: 1,
      backgroundColor: "crimson",
      textShadow: "3px 2px 4px black",
    },

    [`& .${classes.cardAction}`]: {
      //width: "80%",
      [theme.breakpoints.down("sm")]: {
        //width: "70%",
      },
    },

    [`& .${classes.photo}`]: {
      width: "20%",
      [theme.breakpoints.down("sm")]: {
        width: "30%",
      },
      height: "100%",
      display: "inline-block",
      float: "left",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      cursor: "pointer",
    },

    [`& .${classes.content}`]: {
      flex: "1 0 auto",
      textAlign: "left",
    },

    [`& .${classes.icon}`]: {
      height: 24,
      color: "red",
    },

    [`& .${classes.iconGroup}`]: {
      padding: "0.3rem 0",
    },

    [`& .${classes.qty}`]: {
      backgroundColor: "black",
      color: "white",
      width: 16,
      height: 16,
      textAlign: "center",
      position: "relative",
      top: -7,
      left: -7,
      borderRadius: 8,
    },

    [`& .${classes.line}`]: {
      border: "1px solid #09222c",
    },

    [`& .${classes.bottomLine}`]: {
      border: "2px solid #09222c",
    },

    [`& .${classes.modal}`]: {
      alignItems: "center",
      justifyContent: "center",
    },

    [`& .${classes.paper}`]: {
      backgroundColor: theme.palette.background.paper,
    },

    [`& .${classes.large}`]: {
      fontSize: "x-large",
      //whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },

    [`& .${classes.larger}`]: {
      fontSize: "xx-large",
      //whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },

    [`& .${classes.closeIcon}`]: {
      color: "grey",
      position: props.single ? "unset" : "absolute",
      right: props.single ? "unset" : 8,
      top: props.single ? "unset" : 4,
      zIndex: 9,
    },
  }));

  const Ribbon = styled("div")(() => ({
    [`& .${classes.ribbonSoldConditional}`]: {
      backgroundColor: props?.DATA?.STATUS.includes("Final") ? red[900] : orange[900],
    },
  }));
  //eslint-disable-next-line
  const scrollToListing = (listingContainer) => {
    if (listingContainer) {
      setTimeout(() => {
        document.getElementById("appHeader").style.visibility = "hidden";
        document.getElementById(listingContainer).scrollIntoView({
          block: "start",
          inline: "nearest",
          behavior: "smooth",
        });
      }, 1000);
    }
  };

  const AccordionSummary = MuiAccordionSummary;

  const isSelected = () => {
    if (props.DATA.REF === props.selected) return true;
    return false;
  };

  const CardActionArea = MuiCardActionArea;

  const [state, setState] = useState({
    advertise: props.DATA.HF_ADVERTISE,
  });

  const flipToggle = (isChecked) => {
    setState({ advertise: isChecked.toString() });
  };

  const selectHandler = () => () => {
    if (isSelected()) props.setSelected(false);
    else {
      //console.log(props.DATA.REF);
      scrollToListing(props.DATA.REF);
      props.setSelected(props.DATA.REF);
    }
  };

  const buildImageURL = (sml) => {
    try {
      return `https://www.rnslive.co.za/Photos/${props.DATA.REF}/${props.DATA.PHOTOS[0].replace(/_s/g, `_${sml}`)}`;
    } catch (error) {
      let imgURL = `https://www.rnslive.co.za/Photos/${props.DATA.REF}/${props.DATA.REF}_${sml}(01).jpg`;
      return imgURL;
    }
  };

  const removeListing = () => {
    listingRef.current.classList.add("slide-out-right");
    setTimeout(() => {
      //listingRef.current.style.display = "none";
      listingRef.current.remove();
    }, 1000);
  };

  let agencyCode = sessionStorage["agencyCode"] ? sessionStorage["agencyCode"] : null;

  if (testSubject) {
    agencyCode = testSubject.aid;
  }

  if (props.DATA) {
    const iconList = [
      {
        qty: props.DATA.BEDROOMS,
        icon: "double-bed",
        alt: "Bedrooms",
        icononly: false,
      },
      {
        qty: props.DATA.I_ENSUIT,
        icon: "ensuite-solid",
        alt: "Ensuite bathrooms",
        icononly: false,
      },
      {
        qty: props.DATA.I_BATHS,
        icon: "bath-solid",
        alt: "Bathrooms",
        icononly: false,
      },
      {
        qty: props.DATA.I_LOUNNO,
        icon: "love-seat-solid",
        alt: "Lounge",
        icononly: false,
      },
      {
        qty: props.DATA.I_FARONO,
        icon: "family-room",
        alt: "Family room",
        icononly: false,
      },
      {
        qty: props.DATA.I_STDYNO,
        icon: "study-solid",
        alt: "Study",
        icononly: false,
      },
      {
        qty: props.DATA.I_LAUNNO,
        icon: "laundry-solid",
        alt: "Laundry",
        icononly: false,
      },
      {
        qty: props.DATA.I_SCULNO,
        icon: "scullery-solid",
        alt: "Scullery",
        icononly: false,
      },
      {
        qty: props.DATA.I_PANNO,
        icon: "pantry-solid",
        alt: "Pantry",
        icononly: false,
      },
      {
        qty: props.DATA.I_HLBTNO,
        icon: "restroom-solid",
        alt: "Guest loo",
        icononly: false,
      },
      {
        qty: props.DATA.E_SERVNO,
        icon: "staff-solid",
        alt: "Staff quarters",
        icononly: false,
      },
      {
        qty: props.DATA.E_GARANO,
        icon: "garage-open",
        alt: "Garage",
        icononly: false,
      },
      {
        qty: props.DATA.E_CRPRTN,
        icon: "carport-solid",
        alt: "Carport",
        icononly: false,
      },
      {
        qty: props.DATA.E_POOLNO,
        icon: "swimmer-solid",
        alt: "Pool",
        icononly: false,
      },
      {
        qty: props.DATA.G_TOTAL,
        icon: "granny-flat-solid",
        alt: "Granny flat",
        icononly: false,
      },
      {
        qty: props.DATA.T_PETS,
        icon: "paw-solid",
        alt: "Pet friendly",
        icononly: true,
      },
    ];

    function listingSummary() {
      return (
        <Root className={classes.root}>
          {!(window.location.pathname.indexOf("dash") > -1) && (
            <Log listing_id={props.id} conversion_event={!!isSelected() ? "View" : "Display"} conversion_meta={props.display} />
          )}
          {!(!!props.hideThumb || !!isSelected()) && (
            <CardMedia
              className={classes.photo}
              //image={!!isSelected() ? buildImageURL("m") : buildImageURL("s")}
              image={buildImageURL("m")}
            />
          )}
          {(!props.hideThumb && !!isSelected()) && <HighlightOffIcon className={classes.closeIcon} />}
          {!!!isSelected() && (
            <>
              <Love
                display={props.display}
                home={props.DATA.REF}
                single={false}
                makeLove={props.makeLove}
                altAgent={props.altAgent}
                LinkHomeToAgent={props.LinkHomeToAgent}
                removeOnClick={props?.removeOnClick ? props.removeOnClick : false}
                removeListing={removeListing}
                beat={props.hideThumb}
              />
              {props?.DATA?.STATUS.includes("Conditional") ? (
                <Ribbon className="ribbon ribbon-top-right">
                  <span className={classes.ribbonSoldConditional}>Conditional Sale</span>
                </Ribbon>
              ) : null}
              {props?.DATA?.STATUS.includes("Final") ? (
                <Ribbon className="ribbon ribbon-top-right">
                  <span className={classes.ribbonSoldConditional}>Sold</span>
                </Ribbon>
              ) : null}
            </>
          )}
          <CardActionArea className={classes.cardAction}>
            <>
              {!!isSelected() || (
                <>
                  {/* <Typography variant="body1" color="textSecondary">
                      REF: {props.DATA.REF}
                    </Typography> */}
                  {typeof props.isAvailable !== "undefined" && !props.isAvailable && (
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      onClick={(e) => {
                        e.stopPropagation();
                        window.location.reload();
                      }}>
                      ARCHIVED: No longer advertised.
                    </Typography>
                  )}

                  {props.DATA.MANDATE === "RNS Mandate" && (
                    <Typography variant="body1" color="textSecondary" style={{ color: "crimson" }}>
                      Exclusive {props.DATA.MANDATE}
                    </Typography>
                  )}
                </>
              )}
              {sessionStorage["agencyCode"] ? (
                props.DATA.REF.substr(0, 4) === agencyCode ? (
                  props.DATA.FULL_ADDRESS ? (
                    <Typography variant="body1" color="textSecondary" className="trimText blur">
                      {props.DATA.FULL_ADDRESS.toProperCase()}
                    </Typography>
                  ) : (
                    false
                  )
                ) : (
                  false
                )
              ) : (
                false
              )}
            </>
            {props.DATA.HF_TITLE && (
              <Typography
                variant="body2"
                color="textSecondary"
                className={!!isSelected() ? classes.large : "trimText"}
                style={{ width: document.width }}>
                {props.DATA.HF_TITLE}
              </Typography>
            )}
            <Typography
              variant="body2"
              color="textSecondary"
              className={!!isSelected() ? classes.large : "trimText"}
              style={{ width: document.width }}>
              <strong>{props.DATA.TOWN.toProperCase()}</strong>
              &nbsp;| {props.DATA.SUBURB.toProperCase()}
            </Typography>
            <Typography component="h6" variant="h6" className={!!isSelected() ? classes.larger : ""}>
              {props.DATA.PRICE.toString().toZAR()} {props.DATA.MANDATE === "Rental Property" && " p/m"}
            </Typography>
            {(!!isSelected() || props.display === "single") && props.DATA.I_RTSLVY > 0 && (
              <Typography variant="body2" color="textSecondary">
                Rates: {props.DATA.I_RTSLVY.toString().toZAR()} p/m
              </Typography>
            )}
            {(!!isSelected() || props.display === "single") && props.DATA.I_LVY > 0 && (
              <Typography variant="body2" color="textSecondary">
                Levy: {props.DATA.I_LVY.toString().toZAR()} p/m
              </Typography>
            )}
            <>
              {!props.hideThumb || !!isSelected() || (
                <>
                  {props.DATA.MANDATE !== "Rental Property" && !isSelected() && (
                    <Typography component="h6" variant="subtitle1">
                      <Calculate autoPilot={true} purchasePrice={props.DATA.PRICE} loanAmount={props.DATA.PRICE} />
                    </Typography>
                  )}
                </>
              )}
              {!!isSelected() || (
                <>
                  <Typography variant="subtitle2" color="textPrimary">
                    {props.DATA.BEDROOMS > 0
                      ? `${props.DATA.STYLE} ${props.DATA.BEDROOMS} bedroom ${props.DATA.CLASS}`
                      : `${props.DATA.STYLE} ${props.DATA.CLASS}`}
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    {`Photos: ${props.DATA.PHOTO_COUNT}`}
                  </Typography>
                  <Grid container className={classes.iconGroup}>
                    {iconList.map((icon, i) => {
                      return <Icon key={i} icon={icon.icon} alt={icon.alt} qty={icon.qty} icononly={icon.icononly} />;
                    })}
                  </Grid>
                </>
              )}
            </>
          </CardActionArea>
        </Root>
      );
    }
    function listingExpanded() {
      return (
        <Grid item xs={12}>
          {!!isSelected() ? (
            <div>
              <Slide in={!!isSelected()}>
                <div className={classes.paper}>
                  <ListingDetails
                    listing={props}
                    REF={props.DATA.REF}
                    key={props.DATA.REF}
                    aid={props.DATA.AGENTID}
                    image={`https://www.rnslive.co.za/img/Agent_Images/${props.AGENTID}_w200.jpg`}
                    listingImage={props.DATA?.PHOTOS[0]?.replace(/_s/g, "_m")}
                    agent={props.DATA.LISTINGAGENT}
                    altAgent={props.altAgent}
                    LinkHomeToAgent={props.LinkHomeToAgent}
                    agency={props.DATA.LISTINGAGENCY}
                    agencyCode={props.DATA.REF.substr(0, 4)}
                    town={props.DATA.TOWN}
                    class={props.DATA.CLASS}
                    display={props.display}
                    data={props.DATA}
                    makeLove={props.makeLove}
                    isSelected={isSelected}
                  />
                </div>
              </Slide>
            </div>
          ) : (
            false
          )}
        </Grid>
      );
    }

    return (
      <div ref={listingRef}>
        <ControlsRoot id={props.DATA.REF} className={"lovable"}>
          {window.location.pathname.indexOf("dash") > -1 && !!!isSelected() && !!!state.hideThumb && (
            <div className={classes.flex}>
              <AdvertisingToggle flipToggle={flipToggle} advertise={state.advertise} listingID={props.DATA.REF} />
              <div className={classes.flex}>
                <Conversions
                  className={classes.conversions}
                  listing_id={props.DATA.REF}
                  fullAddress={props.DATA.FULL_ADDRESS.toProperCase()}
                />
                {state.advertise === "true" ? (
                  <Booking
                    fullAddress={props.DATA.FULL_ADDRESS.toProperCase()}
                    listingID={props.DATA.REF}
                    location={props.DATA.TOWN}
                    maxDate={props.DATA.MAXDATE}
                  />
                ) : null}
              </div>
            </div>
          )}
          <Accordion
            square
            expanded={isSelected()}
            onChange={
              props.canClick
                ? selectHandler()
                : () => {
                    return false;
                  }
            }
            className={classes.root}>
            <AccordionSummary
              style={{ zIndex: 1, padding: 0 }}
              aria-controls={"pnl-" + props.selected + "-content"}
              id={"pnl-" + props.selected + "-header"}
              classes={{
                root: classes.root,
                content: !!!isSelected() && !props.hideThumb ? classes.content : "",
                expanded: classes.expanded,
              }}>
              {listingSummary()}
            </AccordionSummary>
            <AccordionDetails
              style={{
                margin: 0,
                padding: 0,
                overflow: "auto",
                height: isSelected() ? window.innerHeight - 160 : "unset",
              }}>
              {listingExpanded()}
            </AccordionDetails>
          </Accordion>
        </ControlsRoot>
      </div>
    );
  }
  return null;
};

export const Listing = _Listing;
